import { Observable } from 'rxjs';
import { FixInterval } from '../../features/calendar/components/time-block/types/time-block-types';
import { GroupResult } from '@progress/kendo-data-query';

export type DropdownOption = {
  text: string;
  value: number | string | null;
};

export type GroupedDropdownOption = DropdownOption & {
  category: string;
};

export class DropdownsWithUnassigned<T> extends Observable<T> {}

export const DropdownDefaultItem = {
  text: 'Choose...',
  value: null,
};

export const GroupedDropdownDefaultItem: GroupResult = {
  items: [DropdownDefaultItem],
  value: null,
  field: '',
  aggregates: {},
};

export const TimeOfDayValues: readonly DropdownOption[] = [
  {
    text: 'Ganztags',
    value: FixInterval.FullWorkingDay,
  },
  {
    text: 'Halbtags',
    value: FixInterval.HalfWorkingDay,
  },
] as const;
